/**
 * Permission bitmask constants — re-exported from `@bunker/shared` so
 * server and client read the same numbers. Adding a new bit or changing
 * an existing position now requires editing one file (the shared one)
 * instead of three (per the Codex review).
 */
export {
  PERMISSIONS,
  ALL_PERMISSIONS,
  DEFAULT_MEMBER_PERMISSIONS,
  applyOverridesToPermissions,
  channelOverridePermissions,
  computeMemberPermissions,
  hasPermission,
  type PermissionName,
} from '@bunker/shared/permissions';

/**
 * Quick-reaction emoji palette shown above the message context menu and
 * in the hover-toolbar's pop-out. Keep order stable — users build muscle
 * memory for "first slot is 👍".
 */
export const QUICK_REACTIONS = ['👍', '❤️', '🔥', '😂', '😮', '🎉'] as const;
